import React, { useState } from 'react';

export default function TestSupabaseDebug() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const testSupabase = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Testing Supabase connection...');
      const response = await fetch('/.netlify/functions/test-supabase');
      
      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);
      
      const text = await response.text();
      console.log('Raw response:', text);
      
      try {
        const data = JSON.parse(text);
        setResult(data);
      } catch (parseError) {
        setError(`JSON Parse Error: ${parseError.message}. Raw response: ${text.substring(0, 500)}`);
      }
    } catch (fetchError) {
      setError(`Fetch Error: ${fetchError.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testJobsEndpoint = async () => {
    setLoading(true);
    setError(null);
    setResult(null);

    try {
      console.log('Testing jobs endpoint...');
      const response = await fetch('/.netlify/functions/get-jobs');
      
      console.log('Jobs response status:', response.status);
      
      const text = await response.text();
      console.log('Jobs raw response:', text);
      
      try {
        const data = JSON.parse(text);
        setResult(data);
      } catch (parseError) {
        setError(`JSON Parse Error: ${parseError.message}. Raw response: ${text.substring(0, 500)}`);
      }
    } catch (fetchError) {
      setError(`Fetch Error: ${fetchError.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-c9-blue mb-8">Supabase Debug Test</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <button
            onClick={testSupabase}
            disabled={loading}
            className="bg-c9-orange hover:bg-c9-orange-alt text-white px-6 py-3 rounded-lg font-semibold transition-colors disabled:opacity-50"
          >
            {loading ? 'Testing...' : 'Test Supabase Connection'}
          </button>
          
          <button
            onClick={testJobsEndpoint}
            disabled={loading}
            className="bg-c9-blue hover:bg-c9-blue-alt text-white px-6 py-3 rounded-lg font-semibold transition-colors disabled:opacity-50"
          >
            {loading ? 'Testing...' : 'Test Jobs Endpoint'}
          </button>
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-6 mb-6">
            <h3 className="text-red-800 font-semibold mb-2">Error:</h3>
            <pre className="text-red-700 text-sm whitespace-pre-wrap">{error}</pre>
          </div>
        )}

        {result && (
          <div className="bg-green-50 border border-green-200 rounded-lg p-6">
            <h3 className="text-green-800 font-semibold mb-2">Result:</h3>
            <pre className="text-green-700 text-sm whitespace-pre-wrap overflow-x-auto">
              {JSON.stringify(result, null, 2)}
            </pre>
          </div>
        )}

        <div className="mt-8 bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-c9-blue mb-4">Debug Information</h2>
          <div className="space-y-2 text-sm">
            <p><strong>Current URL:</strong> {window.location.origin}</p>
            <p><strong>Environment:</strong> {process.env.NODE_ENV}</p>
            <p><strong>User Agent:</strong> {navigator.userAgent}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
